import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPitcairnIslands = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_2052)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9679 12H12C12 11.9892 12 11.9787 12 11.9679C11.9893 11.9786 11.9786 11.9893 11.9679 12Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 6.26086C12 4.14937 12 2.76586 12 0H11.998C5.37145 0.001125 0 5.37323 0 12H6.26086V8.47448L9.78638 12H11.9679C11.9786 11.9893 11.9893 11.9786 12 11.9679C12 11.1594 12 10.4381 12 9.78647L8.47444 6.26086H12Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.07103 1.56519C4.1942 2.63389 2.63387 4.19417 1.56522 6.071V12H4.69567V4.69573V4.69564H12C12 3.70831 12 2.76772 12 1.56519H6.07103Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 10.5243L7.73649 6.26086H6.26086V6.26096L11.9999 12H12C12 12 12 10.9824 12 10.5243Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.7826 7.30437L17.2174 7.82613L15.6522 7.30437L15.1305 6.00002L15.6522 4.69568H18.7826L18.2609 6.00002L18.7826 7.30437Z",
				fill: "#ACABB1"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.5652 7.30432V13.0434C13.5652 15.839 17.2174 16.6956 17.2174 16.6956C17.2174 16.6956 20.8696 15.839 20.8696 13.0434V7.30432H13.5652Z",
				fill: "#338AF3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.8944 14.4031C14.7922 16.1266 17.2174 16.6956 17.2174 16.6956C17.2174 16.6956 19.6426 16.1266 20.5404 14.4031L17.2174 8.86957L13.8944 14.4031Z",
				fill: "#6DA544"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20.8696 12.9854L17.2174 7.30432L13.5652 12.9855V13.0434C13.5652 13.5608 13.6906 14.0117 13.8944 14.4031L17.2174 9.23393L20.5404 14.403C20.7442 14.0116 20.8696 13.5608 20.8696 13.0434V12.9854Z",
				fill: "#FFDA44"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_2052",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgPitcairnIslands;
